import { EAccountRoles, IAccountUser } from 'src/types'

export const isUserHaveOnlyScannerRoleForAccounts = (accounts: IAccountUser[]) => {
  // Extract the roles arrays from each account
  const rolesArrays = accounts.map((account) => account.roles)

  // Check if each roles array contains only one role and that role is 'scanner'
  return rolesArrays.every((roles) => roles.length === 1 && roles[0] === EAccountRoles.scanner)
}
